import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { socialApi } from '../api/social-api';

import { socialKeys } from './social-keys';

/** The analytics page in one call: tiles with previous-period values, the daily series, top products. */
export function socialAnalyticsQueryOptions(storeId: string, range: { from: string; to: string }) {
  return queryOptions({
    queryKey: socialKeys.analytics(storeId, range),
    queryFn: () => socialApi.analyticsOverview(storeId, { from: range.from, to: range.to }),
  });
}

/** Keeps the last range on screen while the next one loads, so a range switch never flashes empty tiles. */
export function useSocialAnalytics(storeId: string, range: { from: string; to: string }) {
  return useQuery({
    ...socialAnalyticsQueryOptions(storeId, range),
    placeholderData: keepPreviousData,
  });
}
